import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsSeot4733 } from 'client/utils/seot-4733';
import { SubtypePage, SubtypePageSeo } from './subtype';

function SubtypeRendererUI({ type = null, subtype = null, seot4733Level2SubtypePagesFF = false }) {
  const isSeot4733 = getIsSeot4733(seot4733Level2SubtypePagesFF, type, subtype);
  return isSeot4733 ? <SubtypePageSeo type={type} subtype={subtype} /> : <SubtypePage type={type} subtype={subtype} />;
}

SubtypeRendererUI.propTypes = {
  type: PropTypes.string,
  subtype: PropTypes.string,
  seot4733Level2SubtypePagesFF: PropTypes.bool,
};

const mapStateToProps = state => ({
  seot4733Level2SubtypePagesFF: !!state.featureFlags['seot-4733-level-2-subtype-pages'],
});

export const SubtypeRenderer = connect(mapStateToProps)(SubtypeRendererUI);
